<template lang="pug">
  div.row
    el-card.card-container.just
      h3 Resposta
      el-card
        validation-observer(ref='validation')
          el-row
            el-col(:lg="24", :md="24", :sm="24")
              p.titulo
                | Despacho:
                el-tooltip(class="item" effect="dark" content="Digite @ e o número de uma solicitação para referenciá-la no texto" placement="right-end")
                  i.fa.fa-info-circle
                span.text-danger *
              div.text-despacho
                validation-provider(rules="required", v-slot="{ errors }")
                  app-text-editor(
                    v-model="textoDespacho"
                    :class="{'erro' : errors.length}"
                    :textEditable="true"
                  )
                  div.box-flutuante(v-show="buscando")
                    div.box-color
                      p.text-box-color(v-for="s in solicitacoesComplete", @click="selecionaSolicitacao(s)") {{s.numero}}
                  p.help-erro {{ errors[0] }}
            el-col(:lg="24", :md="24", :sm="24")
              p.titulo
                | Anexos:
              div
                validation-provider(rules="", v-slot="{ errors }")
                  app-anexo(
                    :id="'upload-anexo'"
                    :tiposArquivosPermitidos="'.png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx'"
                    :showAnexar="true"
                    :files="mensagem.anexoCartorios",
                    v-model="mensagem.anexoCartorios",
                    @uploadFile="uploadMapa",
                    @removeFile="removeMapa",
                    @downloadDocumentoCadastro="getDownload",
                    :errors="errors"
                  )
      el-col.container-buttons(:lg="24", :md="24", :sm="24")
        el-button(
          class="btn-danger"
          @click="cancelar()"
        )
          i.fa.fa-times
          span.btn-nova-solicitacao Cancelar
        el-button(
          class="btn-success"
          @click="enviar()"
        )
          i.fa.fa-paper-plane
          span.btn-nova-solicitacao Enviar
</template>

<script>
import AppTextEditor from '@/components/AppTextEditor'
import FileSaver from 'file-saver'
import AppAnexo from '@/components/AppAnexo'
import axios from '@/utils/api'
import { OBJ_TIPO_MENSAGEM } from '@/constants/cartoriosArrecadacao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapGetters } from 'vuex'

export default {
  name: 'SolicitacaoMensagem',
  components: {
    AppTextEditor,
    AppAnexo
  },

  mixins: [AppNotificacao],

  computed: {
    textoDespacho: {
      get () {
        return this.mensagem.despacho
      },
      set (value) {
        const { x, y } = this.getCaretCoordinates()
        document.querySelector('div.box-flutuante').style.left = `${x - 200}px`
        document.querySelector('div.box-flutuante').style.top = `${y - 100}px`
        if (
          value.includes('@') &&
          value.split('@').length &&
          value.split('@')[1][0] !== '<' &&
          value.split('@')[1][0] !== '.' &&
          /^(\(?\+?[0-9]*\)?)?[0-9_\- ()]*$/g.test(
            value.split('@')[value.split('@').length - 1][0]
          )
        ) {
          axios({
            method: 'GET',
            url: `arrecadacao/cartorios/solicitacao/${
              value.split('@')[value.split('@').length - 1].split('<')[0]
            }/existsByNumero`
          }).then(data => {
            this.buscando = true
            this.solicitacoesComplete = JSON.parse(data)
            if (data.length === 0) {
              this.buscando = false
            }
          })
        } else {
          this.buscando = false
          this.mensagem.despacho = value
        }
      }
    }
  },

  data () {
    return {
      solicitacoesComplete: [],
      buscando: false,
      mensagem: {
        descricao: '',
        despacho: '',
        origem: 'SICARF',
        anexoCartorios: [],
        remetente: {
          nome: '',
          cpf: ''
        }
      },
      tipoMensagem: OBJ_TIPO_MENSAGEM,
      disabledPrazo: false,
      idSolicitacao: null,
      idProcesso: null
    }
  },

  mounted () {
    this.idSolicitacao = this.$route.query.idSolicitacao
    this.mensagem.remetente = {
      nome: this.getUsuario().pessoa.nomeRazaoSocial,
      cpf: this.getUsuario().pessoa.cpfCnpj
    }
  },

  methods: {
    ...mapGetters({
      getUsuario: 'auth/usuarioLogado'
    }),

    getCaretCoordinates () {
      let x = 0
      let y = 0
      const isSupported = typeof window.getSelection !== 'undefined'
      if (isSupported) {
        const selection = window.getSelection()
        if (selection.rangeCount !== 0) {
          const range = selection.getRangeAt(0).cloneRange()
          range.collapse(true)
          const rect = range.getClientRects()[0]
          if (rect) {
            x = rect.left
            y = rect.top
          }
        }
      }
      return { x, y }
    },

    onTextChange (text) {
      this.mensagem.despacho = text
    },

    uploadMapa (documento) {
      this.mensagem.anexoCartorios.push({
        key: documento.response,
        nome: documento.name
      })
    },

    removeMapa (documento) {
      const index = this.mensagem.anexoCartorios.indexOf(
        this.mensagem.anexoCartorios.find(m => m.key === documento.key)
      )
      this.mensagem.anexoCartorios.splice(index, 1)
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    async enviar () {
      try {
        if (await this.$refs.validation.validate()) {
          this.confirmBox(
            this.idSolicitacao
              ? this.$messages.CONFIRMAR_RESPOSTA
              : this.$messages.CONFIRMAR_ENVIO,
            this.$messages.TITULO_WARNING,
            async () => {
              await axios({
                method: 'POST',
                url: `arrecadacao/cartorios/solicitacao/mensagem`,
                data: {
                  ...this.mensagem,
                  prazo: new Date(
                    new Date().setDate(new Date().getDate() + 3)
                  ).toISOString(),
                  solicitacao: {
                    id: this.idSolicitacao
                  }
                }
              })

              this.ok()
            },
            () => {}
          )
        } else {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            this.$messages.VERIFICAR_CAMPOS
          )
        }
      } catch (e) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.VERIFICAR_CAMPOS
        )
      }
    },
    async cancelar () {
      this.confirmBox(
        this.$messages.CANCELAR_ANALISE_DEFAULT,
        this.$messages.TITULO_WARNING,
        () => {
          this.$router.back()
        },
        () => {}
      )
    },
    ok () {
      this.$router.back()
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        'Enviada com sucesso.'
      )
    },
    selecionaSolicitacao (valor) {
      this.textoDespacho =
        this.textoDespacho.split('@')[0] +
        `<a href="$$BASE_URL_SISTEMA$$/${valor.id}" target="_blank">${valor.numero}</a>` +
        ('<' + this.textoDespacho.split('@')[1].split('<')[1]) +
        ' '
      this.buscando = false
    },
    verificarData (tipo) {
      this.tipoMensagem.forEach(element => {
        if (element.codigo === tipo) {
          if (element.dias > 0) {
            this.solicitacao.prazo = element.dias
            this.disabledPrazo = true
          } else {
            this.disabledPrazo = false
          }
          return true
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';
.container {
  display: flex;
  width: 90%;
}
.text-despacho {
  position: relative;
}
.box-flutuante {
  background: rgba(255, 255, 255, 1);
  width: 130px;
  z-index: 99999999;
  position: absolute;
}
.fa-info-circle {
  margin-left: 5px;
}
.box-color {
  background-color: #fff;
  border: 1px solid #000000 !important;
  border-radius: 5px;
  width: 130px;
  position: absolute;
  text-align: center;
}
.text-box-color {
  cursor: pointer;
  margin: 0;
}
.text-box-color:hover {
  color: rgb(36, 142, 204);
  background-color: #d9d9d9;
}
.flex {
  display: flex;
}
.flex-around {
  display: flex;
  justify-content: space-around;
  min-width: 160px;
  height: 100%;
  max-width: 215px;
}

.text-danger {
  color: red;
  font-weight: bold;
  margin-left: 5px;
  font-size: 12px;
}

.btn-nova-solicitacao {
  font-size: 15px;
  margin: 10px;
}

.container-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  padding-bottom: 20px;
}

.container-buttons .btn-success {
  background: #009f61;
  border-color: #009f61;
  color: #fff;
  cursor: pointer;
  padding: 8px 10px;
  font-size: 14px;
  border: none;
  border-radius: 5px;
  min-width: 120px;
}

.container-buttons .btn-success:hover {
  color: #e6f5ef;
  border-color: #009f61;
  background-color: #009f61;
}

.fa-paper-plane,
.fa-times {
  font-size: 16px;
  padding: 2px;
}

.padd {
  margin-left: 25px;
}

.container-buttons .btn-danger {
  background: #e66464;
  border-color: #e66464;
  color: #e6f5ef;
  cursor: pointer;
  padding: 8px 10px;
  font-size: 14px;
  border: none;
  border-radius: 5px;
  min-width: 120px;
}

.container-buttons .btn-danger:hover {
  color: #e6f5ef;
  border-color: #d84343;
  background-color: #d84343;
}

.resize {
  resize: none;
}
.col {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-align: center;
  width: 100%;
}
.card-inner {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  width: 90%;
}
@media screen and (max-width: 992px) {
  .flex {
    flex-direction: column;
  }
  .radioButton {
    margin-bottom: 20px;
  }
  .label {
    font-size: 10px;
  }
  .quantidade {
    font-size: 18px;
  }
}
@media screen and (max-width: 1366px) {
  .flex {
    width: 80%;
  }
  .icone {
    font-size: 35px;
    width: 35%;
  }
  .label {
    font-size: 12px;
  }
  .quantidade {
    font-size: 18px;
  }
  .com-prazo {
    width: 55%;
  }
  .sem-prazo {
    width: 65%;
  }
  .legenda li {
    font-size: 12px;
  }
}
</style>

<style>
.el-tooltip__popper {
  font-family: 'Ubuntu', sans-serif !important;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/ResponderMensagem.vue